export const MAX_SMS_LENGTH = 160
export const SMS_CREDIT_CONTACT = 'help@civicchamps.com'
export const SMS_CREDIT_PRICE_PER_SMS = 0.02

